(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["abdominal-parte-once"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (!root || root.dataset.aiaReady === '1') return;
      root.dataset.aiaReady = '1';

      var toggle = root.querySelector('.aia-bw__toggle');
      var toggleText = root.querySelector('.aia-bw__toggle-text');
      var dialog = root.querySelector('.aia-bw__lb');
      var state = { user: false, lightbox: false, offscreen: false, editor: false };

      function apply() {
        root.classList.toggle('is-paused', state.user || state.lightbox || state.offscreen || state.editor);
        root.classList.toggle('is-user-paused', state.user);
      }

      if (toggle) {
        toggle.addEventListener('click', function () {
          state.user = !state.user;
          toggle.setAttribute('aria-label', state.user ? 'Reanudar carrusel' : 'Pausar carrusel');
          if (toggleText) toggleText.textContent = state.user ? 'Reanudar' : 'Pausar';
          apply();
        });
      }

      // Detiene la animación cuando la sección no está en pantalla (ahorra CPU/batería)
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          state.offscreen = !entries[0].isIntersecting;
          apply();
        }, { rootMargin: '100px 0px' }).observe(root);
      }

      // En el editor de temas: pausar mientras se edita un bloque
      root.addEventListener('shopify:block:select', function () { state.editor = true; apply(); });
      root.addEventListener('shopify:block:deselect', function () { state.editor = false; apply(); });

      if (!dialog || typeof dialog.showModal !== 'function') return;

      var items = Array.prototype.slice.call(root.querySelectorAll('.aia-bw__shot[data-full]'));
      var img = dialog.querySelector('.aia-bw__lb-img');
      var count = dialog.querySelector('.aia-bw__lb-count');
      var current = 0;

      function show(i) {
        if (!items.length) return;
        current = (i + items.length) % items.length;
        var btn = items[current];
        img.src = btn.dataset.full;
        img.alt = btn.dataset.alt || '';
        if (count) count.textContent = items.length > 1 ? (current + 1) + ' / ' + items.length : '';
      }

      root.querySelector('.aia-bw__track').addEventListener('click', function (e) {
        var btn = e.target.closest('.aia-bw__shot[data-index]');
        if (!btn) return;
        show(parseInt(btn.dataset.index, 10) || 0);
        dialog.showModal();
        state.lightbox = true;
        apply();
      });

      dialog.addEventListener('close', function () {
        state.lightbox = false;
        img.removeAttribute('src');
        apply();
      });

      // Cerrar al tocar fuera de la imagen
      dialog.addEventListener('click', function (e) {
        if (e.target === dialog) dialog.close();
      });

      dialog.querySelector('.aia-bw__lb-close').addEventListener('click', function () { dialog.close(); });

      var prev = dialog.querySelector('.aia-bw__lb-prev');
      var next = dialog.querySelector('.aia-bw__lb-next');
      if (prev) prev.addEventListener('click', function () { show(current - 1); });
      if (next) next.addEventListener('click', function () { show(current + 1); });

      dialog.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') { e.preventDefault(); show(current - 1); }
        if (e.key === 'ArrowRight') { e.preventDefault(); show(current + 1); }
      });

      // Deslizar en móvil
      var startX = null;
      dialog.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
      dialog.addEventListener('touchend', function (e) {
        if (startX === null) return;
        var dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) > 50) show(current + (dx < 0 ? 1 : -1));
        startX = null;
      });
    }

    function initAll() {
      document.querySelectorAll('.aia-bw').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (e) {
      init(e.target.querySelector('.aia-bw'));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
